export type DynamicSessionModel = {
	metaSiteId: string
	apps: {
		[appDefId: string]: {
			instance: string
		}
	}
	ctToken: string
	hs: number
	mediaAuthToken: string
	svSession: string
	visitorId: string
	siteMemberId?: string
	contactId?: string
	smToken?: string
}

export type FetchDynamicModel = (init?: RequestInit) => Promise<DynamicSessionModel>

export type Instance = string
export type LoadNewSessionReason =
	| 'noSpecificReason'
	| 'memberLogin'
	| 'expiry'
	| 'newUserSession'
	| 'firstLoad'
	| 'authorization code expiry'

export const AUTHORIZATION_CODE_QUERY_PARAM = 'authorizationCode'

export type OnLoadSessionCallback = ({
	results,
	reason,
}: {
	results: {
		instances: { [appDefinitionId: string]: Instance }
		siteMemberId?: string
		visitorId?: string
		svSession?: string
		smToken?: string
	}
	reason: LoadNewSessionReason
}) => void

export interface ISessionManager {
	getBoundAccessTokenFunction: (appDefId: string) => () => Promise<string>
	getAppInstanceByAppDefId(appDefId: string): string | undefined
	getAccessTokenByAppDefId(appDefId: string): string | undefined
	getSiteMemberId(): string | undefined
	getVisitorId(): string | undefined
	getSmToken(): string | undefined
	clearMemberSession(): void
	getUserSession(): string | undefined
	getCtToken(): string | undefined
	getContactId(): string | undefined
	getAllInstances(): DynamicSessionModel['apps']
	getHubSecurityToken(): string | 'NO_HS'
	setUserSession(userSession: string): void
	addLoadNewSessionCallback(callback: OnLoadSessionCallback): () => void
	// @ts-ignore
	loadNewSession({
		reason,
		authorizationCode,
	}?: {
		reason: LoadNewSessionReason
		authorizationCode?: string
	}): Promise<void>
}

export interface ISessionProvider {
	getCurrentSession: () => Partial<DynamicSessionModel> | undefined
	loadNewSession: (param: {
		reason: LoadNewSessionReason
		authorizationCode?: string
	}) => Promise<Partial<DynamicSessionModel>>
}
